// extracted by mini-css-extract-plugin
export var divider = "_2i-0";
export var dividerText = "_2i-1";